import { withInstall } from '@pc-fx-framework/utils/with-install'
import VRosePieChart from './src/index.vue'

export const FxVRosePieChart = withInstall(VRosePieChart)
export default FxVRosePieChart
